const actions = {
  setLastClosed(context) {
    const now = Date.now();
    context.commit('SET_LAST_CLOSED', now);
  },
};

export default actions;
